import React, { useState } from 'react'
import BatchUserDetails from '../components/Programs/BatchUserDetails';
const BatchUserDetailsLayout = () => {

    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = (value) => {
        setToggled(value);
    };

    return (
        <>
            {/* <Aside
                  rtl={rtl}
                  toggled={toggled}
                  handleToggleSidebar={handleToggleSidebar}
              /> */}
            <BatchUserDetails handleToggleSidebar={handleToggleSidebar} />
        </>
    )
}

export default BatchUserDetailsLayout